<form [formGroup]='floatInterestPayRecForm'>
    <div class="row">
        <div class="col-lg-3 form-group">
            <label>Float Rate Benchmark<span class="red">*</span>
            </label>
            <select class="form-control form-control-sm selectpicker" formControlName="floatRateBenchMark"
                title="Select Float Rate Benchmark" data-live-search="true" (change)="onSubmit();onChangeBenchmark()">
                <option *ngFor="let data of benchmarkList" value="{{data.benchmarkRates}}">
                    {{data.benchmarkRates}}
                </option>
            </select>
            <div *ngIf="g.floatRateBenchMark.invalid && g.floatRateBenchMark.touched">
                <p *ngIf="g.floatRateBenchMark.errors.required" class="error nocase">
                    Please enter Float Rate Benchmark
                </p>
            </div>
        </div>
        <div class="col-lg-3 form-group">
            <legend class="mt-2">Backward Effective Flag <span class="red">*</span></legend>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="backwrdEffDateFlg" name="backwrdEffDateFlg" value="Y"
                    class="form-check-input" (change)="onSubmit()"
                    [ngClass]="{'is-invalid': (g.backwrdEffDateFlg.touched) && g.backwrdEffDateFlg.errors}">
                <label class="form-check-label">Yes</label>
            </div>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="backwrdEffDateFlg" name="backwrdEffDateFlg" value="N"
                    class="form-check-input" (change)="onSubmit()"
                    [ngClass]="{'is-invalid': (g.backwrdEffDateFlg.touched) && g.backwrdEffDateFlg.errors}">
                <label class="form-check-label">No</label>
            </div>
            <p *ngIf="g.backwrdEffDateFlg.invalid && g.backwrdEffDateFlg.touched" class="error">
                Enter select Backward Effective Flag
            </p>
        </div>

        <div class="col-lg-3 form-group">
            <label>Effective Date</label><span class="red">*</span>
            <div class="input-group">
                <input type="text" class="form-control form-control-sm datepicker" formControlName="effectiveDate"
                    bsDatepicker [bsConfig]="{ isAnimated: true}" placeholder="Select Effective Date"
                    [(bsValue)]="bsValue[0]" (ngModelChange)="onSubmit();getPaymentSchedule()">
                <div class="input-group-append pointer">
                    <span class="input-group-text">
                        <i class="fa fa-calendar" bsDatepicker [bsConfig]="{ isAnimated: true }"
                            [ngClass]="g.effectiveDate.disabled?'disabled':''" [(bsValue)]="bsValue[0]"></i>
                    </span>
                </div>
            </div>
        </div>
        <div class="col-lg-3 form-group">
            <label>Designated Maturity<span class="red">*</span>
            </label>
            <select class="form-control form-control-sm selectpicker" formControlName="designatedMaturity"
                title="Select Designated Maturity" data-live-search="true" (change)="onSubmit();detectChange()">
                <option *ngFor="let data of designatedMaturityList" value="{{data}}">
                    {{data}}
                </option>
            </select>
            <p *ngIf="g.designatedMaturity.invalid && g.designatedMaturity.touched" class="error nocase">
                Please select Designated Maturity
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <label>Reset Date Specification<span class="red">*</span>
            </label>
            <select class="form-control form-control-sm selectpicker" formControlName="resetDateSpec"
                title="Select Reset Date Speciication" data-live-search="true" (change)="onSubmit();detectChange()">
                <option *ngFor="let data of resetDateSpecList" value="{{data}}">
                    {{data}}
                </option>
            </select>
            <p *ngIf="g.resetDateSpec.invalid && g.resetDateSpec.touched" class="error nocase">
                Please select Reset Date Speciication
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <label>Spread %</label>
            <input type="number" class="form-control form-control-sm" formControlName="spread"
                (change)="onSubmit();detectChange()">
        </div>
        <div class="col-lg-3 form-group"
            *ngIf="g.designatedMaturity.value=='ON' && g.resetDateSpec.value=='Other (OIS)' && g.spread.value>0">
            <label>Compounding Type for Spread<span class="red">*</span></label>
            <select class="form-control form-control-sm selectpicker" formControlName="compoundingTypeSpread"
                title="Select Compounding Type for Spread" data-live-search="true" (change)="onSubmit()"
                [required]="g.designatedMaturity.value=='ON' && g.resetDateSpec.value=='Other (OIS)' && g.spread.value>0">
                <option *ngFor="let data of compoundingTypeSpreadArray" value="{{data}}">
                    {{data}}
                </option>
            </select>
            <p *ngIf="g.resetDateSpec.invalid && g.resetDateSpec.touched" class="error nocase">
                Please select Compounding Type for Spread
            </p>
        </div>
    </div>
    <div class="row">
        <div class="col-lg-3 form-group">
            <label>Day Count Fraction<span class="red">*</span></label>
            <select class="form-control form-control-sm selectpicker" formControlName="dayCountFraction"
                title="Select Day Count Fraction" data-live-search="true" (change)="onSubmit()">
                <option *ngFor="let data of dayCountFractionList" value="{{data}}">
                    {{data}}
                </option>
            </select>
            <p *ngIf="g.dayCountFraction.invalid && g.dayCountFraction.touched" class="error nocase">
                Please select Day Count Fraction
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <label>Premium Currency Code</label>
            <select class="form-control form-control-sm selectpicker" formControlName="premCurncyCode"
                title="Select Premium Currency Code" data-live-search="true" (change)="onSubmit()">
                <option *ngFor="let data of currencyList" value="{{data.currencyCode}}">
                    {{data.currencyCode +" - "+ data.currency}}
                </option>
            </select>
            <p *ngIf="g.premCurncyCode.invalid && g.premCurncyCode.touched" class="error nocase">
                Please select Premium Currency Code
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <label>Premium Payment Date</label>
            <div class="input-group">
                <input type="text" class="form-control form-control-sm datepicker" formControlName="premPaymntDate"
                    bsDatepicker [bsConfig]="{ isAnimated: true}" placeholder="Select Premium Payment Date"
                    [(bsValue)]="bsValue[1]" (ngModelChange)="onSubmit()">
                <div class="input-group-append pointer">
                    <span class="input-group-text">
                        <i class="fa fa-calendar" bsDatepicker [bsConfig]="{ isAnimated: true }"
                            [ngClass]="g.premPaymntDate.disabled?'disabled':''" [(bsValue)]="bsValue[1]"></i>
                    </span>
                </div>
            </div>
        </div>
        <div class="col-lg-3 form-group">
            <label>Premium Amount Pay/Receive</label>
            <input type="number" class="form-control form-control-sm" formControlName="premPAmtPayRecv"
                (change)="onSubmit()">
        </div>
    </div>
    <div class="row">
        <div class="col-lg-3 form-group">
            <legend class="mt-2">Stub <span class="red">*</span></legend>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="stub" name="stub" value="Y" class="form-check-input"
                    [ngClass]="{'is-invalid': (g.stub.touched) && g.stub.errors}" (change)="onSubmit();stubChange()">
                <label class="form-check-label">Yes</label>
            </div>
            <div class="form-check form-check-inline">
                <input type="radio" formControlName="stub" name="stub" value="N" class="form-check-input"
                    [ngClass]="{'is-invalid': (g.stub.touched) && g.stub.errors}" (change)="onSubmit();stubChange()">
                <label class="form-check-label">No</label>
            </div>
            <p *ngIf="g.stub.invalid && g.stub.touched" class="error">
                Enter select Stub
            </p>
        </div>
        <div class="col-lg-3 form-group" *ngIf="g.stub.value=='Y'">
            <label>Interpolation of Stub</label>
            <select class="form-control form-control-sm selectpicker" formControlName="interpolationOfStub"
                title="Select Interpolation of Stub" data-live-search="true" (change)="onSubmit()">
                <option *ngFor="let data of interpolationOfStubArray" value="{{data}}">
                    {{data}}
                </option>
            </select>
            <p *ngIf="g.interpolationOfStub.invalid && g.interpolationOfStub.touched" class="error nocase">
                Please select Interpolation of Stub
            </p>
        </div>
        <div class="col-lg-3 form-group" *ngIf="g.stub.value=='Y'">
            <label>First Payment Date<span class="red">*</span></label>
            <div class="input-group">
                <input type="text" class="form-control form-control-sm datepicker" formControlName="firstPaymentDate"
                    bsDatepicker [bsConfig]="{ isAnimated: true}" (ngModelChange)="onSubmit()" [(bsValue)]="bsValue[2]"
                    placeholder="Select First Payment Date">
                <div class="input-group-append pointer">
                    <span class="input-group-text">
                        <i class="fa fa-calendar" bsDatepicker [bsConfig]="{ isAnimated: true }"
                            [ngClass]="g.firstPaymentDate.disabled?'disabled':''" [(bsValue)]="bsValue[2]"></i>
                    </span>
                </div>
            </div>
            <p *ngIf="g.firstPaymentDate.invalid && g.firstPaymentDate.touched" class="error">
                Please select First Payment Date
            </p>
        </div>
        <div class="col-lg-3 form-group" *ngIf="g.stub.value=='Y'">
            <label>First Reset Date<span class="red">*</span></label>
            <div class="input-group">
                <input type="text" class="form-control form-control-sm datepicker" formControlName="firstResetDate"
                    bsDatepicker [bsConfig]="{ isAnimated: true}" (ngModelChange)="onSubmit()" [(bsValue)]="bsValue[3]"
                    placeholder="Select First Reset Date">
                <div class="input-group-append pointer">
                    <span class="input-group-text">
                        <i class="fa fa-calendar" bsDatepicker [bsConfig]="{ isAnimated: true }"
                            [ngClass]="g.firstResetDate.disabled?'disabled':''" [(bsValue)]="bsValue[3]"></i>
                    </span>
                </div>
            </div>
            <p *ngIf="g.firstResetDate.invalid && g.firstResetDate.touched" class="error">
                Please select First Reset Date
            </p>
        </div>
        <div class="col-lg-3 form-group">
            <label>No. Of Repetition</label><span class="red">*</span>
            <input type="text" class="form-control form-control-sm" formControlName="noOfRepetition"
                (change)="onSubmit();getPaymentSchedule()">
        </div>
        <div class="col-lg-3 form-group">
            <label>Payment Frequency</label><span class="red">*</span>
            <select class="form-control form-control-sm selectpicker" formControlName="paymentFreqncy"
                title="Select Payment Frequency" data-live-search="true" (change)="onSubmit();getPaymentSchedule()">
                <option *ngFor="let data of paymentFreqList" value="{{data}}">
                    {{data}}
                </option>
            </select>
            <p *ngIf="g.paymentFreqncy.invalid && g.paymentFreqncy.touched" class="error nocase">
                Please select Payment Frequency
            </p>
        </div>
    </div>
    <div class="row mt-2 mb-2">
        <div class="col-lg-6">
            <a class="btn btn-link nocase" data-toggle="modal" attr.data-target="{{'#'+floatInterestFormGroupName}}">
                <h4>Click here to input Payment Dates </h4>
            </a>
        </div>
    </div>
    <div class="modal fade" attr.id="{{floatInterestFormGroupName}}" tabindex="-1" role="dialog"
        aria-labelledby="floatPaymentModalTitle" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header card-header">
                    <h5 class="modal-title ">Input Payment Dates</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <app-amrt-acrt-schedule formType="floatPaymentSchedule" [irsFormData]="paymentData"
                        [dropdownData]="dropDownData" [action]="action"
                        (formUpdate)="formUpdate($event)"></app-amrt-acrt-schedule>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary" data-dismiss="modal">Save Changes </button>
                </div>
            </div>
        </div>
    </div>
</form>